import { alpha, Avatar, Box, useTheme } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { FC } from 'react'
import { EntityAvatar } from 'theme/components'
import { DensityStyleTypes } from 'types'

interface OwnerCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const OwnerCell: FC<OwnerCellProps> = ({ params, densityStyles }) => {
  const theme = useTheme()
  const owner = params?.row?.owner ?? null

  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {owner ? (
        <EntityAvatar
          userId={owner?.user_uuid}
          photoUrl={owner?.image_512}
          size={densityStyles?.size}
          enableNav
          tooltip={owner?.name}
        />
      ) : (
        <Box
          sx={{
            width: densityStyles.avatarSize,
            height: densityStyles.avatarSize,
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: alpha(theme.palette.text.primary, 0.6),
            fontSize: densityStyles.fontSize,
          }}
        >
          <Avatar
            sx={{ bgcolor: 'text.disabled', height: densityStyles.avatarSize, width: densityStyles.avatarSize }}
          />
        </Box>
      )}
    </Box>
  )
}
export default OwnerCell
